import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-80" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", {
    id: "app-component",
    class: "relative min-h-screen bg-amff-navi",
    style: {
      '--header-height': _ctx.headerHeight ? `${_ctx.headerHeight}px` : null,
    }
  }, [
    _createVNode(_component_Header, {
      "onUpdate:headerHeight": _cache[1] || (_cache[1] = (val) => (_ctx.headerHeight = val))
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_Footer, { class: "absolute bottom-0" })
  ], 4))
}